import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StockService } from '../../stock/stock.service';
import { Stock, GetStocksRequest } from '../../stock/stock.type';

export interface RelatedStocksDialogData {
  email: string;
}

@Component({
  selector: 'app-related-stocks-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
  ],
  templateUrl: './related-stocks-dialog.html',
  styleUrl: './related-stocks-dialog.scss'
})
export class RelatedStocksDialog implements OnInit {
  // One persistent stock per account, so this is at most a single row now —
  // stock_index and stock_date are gone with the daily-stock model.
  displayedColumns: string[] = ['supplier', 'status', 'remained_coins', 'coins_to_be_remain', 'updated_at'];
  stocks: Stock[] = [];
  loading: boolean = true;
  email: string;

  constructor(
    private dialogRef: MatDialogRef<RelatedStocksDialog>,
    @Inject(MAT_DIALOG_DATA) public data: RelatedStocksDialogData,
    private stockService: StockService,
    private snackBar: MatSnackBar
  ) {
    this.email = data.email;
  }

  ngOnInit(): void {
    this.loadRelatedStocks();
  }

  loadRelatedStocks(): void {
    this.loading = true;

    const request: GetStocksRequest = {
      search: this.email,
      pageIndex: 0,
      pageSize: 100
    };

    this.stockService.getStocks(request).subscribe({
      next: (response) => {
        this.stocks = response.stocks ?? [];
        this.loading = false;

        if (this.stocks.length === 0) {
          this.snackBar.open('No stocks found for this email', 'Close', { duration: 3000 });
        }
      },
      error: (error) => {
        console.error('Failed to load related stocks:', error);
        this.snackBar.open('Error loading related stocks', 'Close', { duration: 5000 });
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Done':
        return 'status-done';
      case 'Issue':
        return 'status-issue';
      case 'Ready':
        return 'status-ready';
      case 'Transferring':
        return 'status-transferring';
      case 'Password':
      case 'Code':
      case 'Value':
        return 'status-warning';
      case 'Transfer Lock':
      case 'In Game':
        return 'status-info';
      default:
        return 'status-default';
    }
  }

  getPaymentStatusClass(status: string): string {
    return status === 'Payed' ? 'payment-payed' : 'payment-not-payed';
  }
}
